module.exports = __webpack_public_path__ + "static/media/squirrel_portfolio.94e760d5.jpg";